export const translations = {
  en: {
    nav: { home: "Home", services: "Services", projects: "Projects", about: "About Us", contact: "Contact" },
    brand: { sub: "Tandur · Telangana" },
    footer: {
      quickLinks: "Quick Links",
      services: "Services",
      reachUs: "Reach Us",
      rights: "V.B. Sharada Associates. All rights reserved.",
      tagline: "Contracting · Planning · Construction · Interiors",
    },
    home: {
      eyebrow: "Contracting · Planning · Construction · Interiors",
      h1a: "Building Tandur's Future, ",
      h1b: "One Structure",
      h1c: " at a Time",
      heroPara:
        "V.B. Sharada Associates is a professional contracting, building planning, construction, interiors and engineering services firm delivering precision-engineered projects across Tandur and Telangana.",
      consultBtn: "Get a Free Consultation",
      projectsBtn: "View Our Projects",
      badgeTitle: "Trusted Since 2010",
      badgeSub: "Quality-certified execution",
      servicesEyebrow: "What We Do",
      servicesH2: "Five Disciplines. One Accountable Partner.",
      allServices: "All Services",
      learnMore: "Learn more",
      helpTitle: "Not sure where to start?",
      helpText: "Share your plot or space details and we will recommend the right approach, budget and timeline.",
      helpBtn: "Talk to an Engineer",
      featuredEyebrow: "Recent Work",
      featuredH2: "Featured Projects Across Telangana",
      allProjects: "All Projects",
      estEyebrow: "Plan Your Budget",
      estH2: "Estimate Your Project in 10 Seconds",
      testiEyebrow: "Client Voices",
      testiH2: "Trusted by Families & Businesses",
      ctaH2: "Have a plot, plan or project in mind?",
      ctaText: "Visit our Tandur office, call us, or send an enquiry — our engineers respond within one working day.",
      ctaBtn: "Start Your Project",
    },
    svc: {
      eyebrow: "Our Services",
      h1: "Complete Building Services Under One Roof",
      para: "From the first sketch to the final handover key — one accountable team for design, approvals, construction and interiors.",
      enquire: "Enquire about this service",
      ctaH2: "Ready to discuss your requirement?",
      ctaBtn: "Get in Touch",
    },
    prj: {
      eyebrow: "Our Portfolio",
      h1: "Projects That Speak for Our Craft",
      para: "A selection of residential, commercial, interior and structural planning engagements across Tandur and neighbouring districts.",
      empty: "No projects in this category yet.",
      disclaimer: "* Project names and photos shown are representative samples — updated portfolio coming soon.",
    },
    abt: {
      eyebrow: "About Us",
      h1: "Rooted in Tandur. Built on Engineering.",
      whoH2: "Who We Are",
      p1: "V.B. Sharada Associates is a professional contracting, building planning, building construction, interiors and engineering services firm headquartered on Hyderabad Road, Tandur. For over fifteen years we have helped families, farmers, professionals and businesses across Telangana turn plots and ideas into dependable, beautiful structures.",
      p2: "What sets us apart is integration: planning, approvals, construction and interiors are handled by one accountable team — so nothing is lost between an architect, a contractor and a vendor.",
      standardsEyebrow: "Our Standards",
      whyH2: "Why Clients Choose Us",
      leadEyebrow: "Leadership Note",
      quote:
        "A building is a promise made in concrete and steel. We keep that promise with honest estimates, sound engineering and finishing we would accept in our own homes.",
      leadBy: "— Founder & Principal Engineer, V.B. Sharada Associates",
      officeH3: "Visit Our Office",
      contactBtn: "Contact Us",
    },
    values: {
      quality: {
        title: "Quality Without Compromise",
        text: "Branded materials, stage-wise quality checks and engineer supervision on every site, every day.",
      },
      engineering: {
        title: "Engineering-First Approach",
        text: "Every decision — from footing depth to finishing grade — is backed by drawings, data and experience.",
      },
      transparency: {
        title: "Transparent Client Partnership",
        text: "Written estimates, milestone billing and weekly progress updates keep you in full control.",
      },
      equipment: {
        title: "Own Equipment & Workforce",
        text: "In-house shuttering, centering material, machinery and trained crews mean no third-party delays.",
      },
    },
    con: {
      eyebrow: "Contact Us",
      h1: "Let's Talk About Your Project",
      para: "Send an enquiry, chat on WhatsApp, or walk into our Tandur office — we respond within one working day.",
      formH2: "Send an Enquiry",
      officeH3: "Office Details",
      whatsappBtn: "Chat on WhatsApp",
      directionsBtn: "Get Directions",
      mapH2: "Find Us on the Map",
    },
    form: {
      name: "Full Name *",
      phone: "Phone *",
      email: "Email",
      service: "Service Needed",
      details: "Project Details",
      namePh: "Your name",
      servicePh: "Select a service",
      msgPh: "Tell us about your plot, building or interior requirement...",
      submit: "Submit Enquiry",
      submitting: "Submitting...",
      errRequired: "Please enter your name and phone number.",
      success: "Enquiry submitted! Our team will contact you shortly.",
      errFail: "Could not submit the enquiry. Please call or WhatsApp us instead.",
    },
    est: {
      title: "Project Cost Estimator",
      subtitle: "Instant indicative budget",
      type: "Project Type",
      area: "Built-up Area (sq.ft)",
      grade: "Finishing Grade",
      calculate: "Calculate Estimate",
      budget: "Estimated Budget",
      rate: "Rate Applied",
      timeline: "Indicative Timeline",
      months: "months",
      perSqft: "/sq.ft",
      disclaimer: "Indicative only. Final quote depends on site conditions, materials & drawings.",
      discuss: "Discuss This Estimate",
    },
    types: {
      Residential: "Residential",
      Commercial: "Commercial",
      Interiors: "Interiors",
      "Structural Plan": "Structural Plan",
    },
    grades: { Standard: "Standard", Premium: "Premium", Luxury: "Luxury" },
    cat: {
      All: "All",
      "Residential Villas": "Residential Villas",
      "Commercial Complexes": "Commercial Complexes",
      Interiors: "Interiors",
      "Structural Planning": "Structural Planning",
    },
    status: {
      New: "New",
      Contacted: "Contacted",
      "In Review": "In Review",
      Completed: "Completed",
      "In Progress": "In Progress",
      Upcoming: "Upcoming",
    },
    loc: {
      Tandur: "Tandur",
      Kodangal: "Kodangal",
      Peddamul: "Peddamul",
      Vikarabad: "Vikarabad",
      Telangana: "Telangana",
    },
  },
  te: {
    nav: { home: "హోమ్", services: "సేవలు", projects: "ప్రాజెక్టులు", about: "మా గురించి", contact: "సంప్రదించండి" },
    brand: { sub: "తాండూరు · తెలంగాణ" },
    footer: {
      quickLinks: "త్వరిత లింకులు",
      services: "సేవలు",
      reachUs: "మమ్మల్ని చేరుకోండి",
      rights: "V.B. శారద అసోసియేట్స్. అన్ని హక్కులు ప్రత్యేకం.",
      tagline: "కాంట్రాక్టింగ్ · ప్లానింగ్ · కన్స్ట్రక్షన్ · ఇంటీరియర్స్",
    },
    home: {
      eyebrow: "కాంట్రాక్టింగ్ · ప్లానింగ్ · కన్స్ట్రక్షన్ · ఇంటీరియర్స్",
      h1a: "తాండూరు భవిష్యత్తును కడుతున్నాం — ",
      h1b: "ఒక్కో నిర్మాణంతో",
      h1c: "",
      heroPara:
        "V.B. శారద అసోసియేట్స్ — తాండూరు మరియు తెలంగాణ అంతటా ఖచ్చితమైన ఇంజనీరింగ్ ప్రాజెక్టులను అందించే ప్రొఫెషనల్ కాంట్రాక్టింగ్, బిల్డింగ్ ప్లానింగ్, కన్స్ట్రక్షన్, ఇంటీరియర్స్ మరియు ఇంజనీరింగ్ సేవల సంస్థ.",
      consultBtn: "ఉచిత సలహా పొందండి",
      projectsBtn: "మా ప్రాజెక్టులు చూడండి",
      badgeTitle: "2010 నుండి విశ్వసనీయం",
      badgeSub: "నాణ్యత-ధృవీకృత అమలు",
      servicesEyebrow: "మేము చేసేవి",
      servicesH2: "ఐదు విభాగాలు. ఒకే బాధ్యతాయుత భాగస్వామి.",
      allServices: "అన్ని సేవలు",
      learnMore: "మరింత తెలుసుకోండి",
      helpTitle: "ఎక్కడ నుండి మొదలుపెట్టాలో తెలియదా?",
      helpText: "మీ ప్లాట్ లేదా స్థలం వివరాలు పంచుకోండి — సరైన విధానం, బడ్జెట్ మరియు కాలవ్యవధిని మేము సూచిస్తాం.",
      helpBtn: "ఇంజనీర్‌తో మాట్లాడండి",
      featuredEyebrow: "ఇటీవలి పనులు",
      featuredH2: "తెలంగాణ అంతటా ప్రధాన ప్రాజెక్టులు",
      allProjects: "అన్ని ప్రాజెక్టులు",
      estEyebrow: "మీ బడ్జెట్ ప్లాన్ చేసుకోండి",
      estH2: "10 సెకన్లలో మీ ప్రాజెక్టు అంచనా పొందండి",
      testiEyebrow: "క్లయింట్ల మాటలు",
      testiH2: "కుటుంబాలు & వ్యాపారాల విశ్వాసం",
      ctaH2: "ప్లాట్, ప్లాన్ లేదా ప్రాజెక్టు ఆలోచన ఉందా?",
      ctaText: "మా తాండూరు కార్యాలయానికి రండి, కాల్ చేయండి లేదా ఎంక్వైరీ పంపండి — మా ఇంజనీర్లు ఒక పనిదినంలో స్పందిస్తారు.",
      ctaBtn: "మీ ప్రాజెక్టు ప్రారంభించండి",
    },
    svc: {
      eyebrow: "మా సేవలు",
      h1: "ఒకే ఆశ్రయంలో సంపూర్ణ బిల్డింగ్ సేవలు",
      para: "మొదటి స్కెచ్ నుండి చివరి హ్యాండోవర్ కీ వరకు — డిజైన్, అప్రూవల్స్, కన్స్ట్రక్షన్ మరియు ఇంటీరియర్స్ కోసం ఒకే బాధ్యతాయుత బృందం.",
      enquire: "ఈ సేవ గురించి అడగండి",
      ctaH2: "మీ అవసరం గురించి చర్చించడానికి సిద్ధంగా ఉన్నారా?",
      ctaBtn: "సంప్రదించండి",
    },
    prj: {
      eyebrow: "మా పోర్ట్‌ఫోలియో",
      h1: "మా నైపుణ్యానికి సాక్ష్యమైన ప్రాజెక్టులు",
      para: "తాండూరు మరియు పక్క జిల్లాల్లో రెసిడెన్షియల్, కమర్షియల్, ఇంటీరియర్ మరియు స్ట్రక్చరల్ ప్లానింగ్ పనుల సేకరణ.",
      empty: "ఈ వర్గంలో ఇంకా ప్రాజెక్టులు లేవు.",
      disclaimer: "* చూపిన ప్రాజెక్టు పేర్లు మరియు ఫోటోలు ప్రాతినిధ్య నమూనాలు — త్వరలో అసలు పోర్ట్‌ఫోలియో.",
    },
    abt: {
      eyebrow: "మా గురించి",
      h1: "తాండూరులో వేళ్లు. ఇంజనీరింగ్‌పై పునాది.",
      whoH2: "మేము ఎవరు",
      p1: "V.B. శారద అసోసియేట్స్ అనేది తాండూరు హైదరాబాద్ రోడ్‌లో ప్రధాన కార్యాలయం కలిగిన ప్రొఫెషనల్ కాంట్రాక్టింగ్, బిల్డింగ్ ప్లానింగ్, బిల్డింగ్ కన్స్ట్రక్షన్, ఇంటీరియర్స్ మరియు ఇంజనీరింగ్ సేవల సంస్థ. పదిహేనేళ్లుగా తెలంగాణ అంతటా కుటుంబాలు, రైతులు, ఉద్యోగులు మరియు వ్యాపారాల ప్లాట్‌లను, ఆలోచనలను నమ్మకమైన, అందమైన నిర్మాణాలుగా మార్చడంలో సహాయపడుతున్నాం.",
      p2: "మమ్మల్ని ప్రత్యేకం చేసేది ఏకీకరణ: ప్లానింగ్, అప్రూవల్స్, కన్స్ట్రక్షన్ మరియు ఇంటీరియర్స్ అన్నీ ఒకే బాధ్యతాయుత బృందం చే నిర్వహించబడతాయి — ఆర్కిటెక్ట్, కాంట్రాక్టర్ మరియు వెండార్ మధ్య ఏదీ కోల్పోదు.",
      standardsEyebrow: "మా ప్రమాణాలు",
      whyH2: "క్లయింట్లు మమ్మల్ని ఎందుకు ఎంచుకుంటారు",
      leadEyebrow: "నాయకత్వ సందేశం",
      quote:
        "భవనం అనేది కాంక్రీటు మరియు ఉక్కుతో ఇచ్చిన మాట. నిజాయితీ అంచనాలు, బలమైన ఇంజనీరింగ్ మరియు మా స్వంత ఇళ్లలో అంగీకరించే ఫినిషింగ్‌తో మేము ఆ మాట నిలబెడతాం.",
      leadBy: "— వ్యవస్థాపకుడు & ప్రధాన ఇంజనీర్, V.B. శారద అసోసియేట్స్",
      officeH3: "మా కార్యాలయానికి రండి",
      contactBtn: "సంప్రదించండి",
    },
    values: {
      quality: {
        title: "రాజీలేని నాణ్యత",
        text: "బ్రాండెడ్ మటీరియల్స్, దశలవారీ నాణ్యతా తనిఖీలు మరియు ప్రతీ సైట్‌లో ప్రతిరోజూ ఇంజనీర్ పర్యవేక్షణ.",
      },
      engineering: {
        title: "ఇంజనీరింగ్-ముందు విధానం",
        text: "పునాది లోతు నుండి ఫినిషింగ్ గ్రేడ్ వరకు ప్రతీ నిర్ణయం డ్రాయింగ్‌లు, డేటా మరియు అనుభవంతో నిర్ధారించబడుతుంది.",
      },
      transparency: {
        title: "పారదర్శక క్లయింట్ భాగస్వామ్యం",
        text: "రాతపూర్వక అంచనాలు, మైల్‌స్టోన్ బిల్లింగ్ మరియు వారపు పురోగతి అప్‌డేట్‌లు మిమ్మల్ని పూర్తి నియంత్రణలో ఉంచుతాయి.",
      },
      equipment: {
        title: "స్వంత పరికరాలు & కార్మికులు",
        text: "స్వంత షట్టరింగ్, సెంటరింగ్ మటీరియల్, యంత్రాలు మరియు శిక్షణ పొందిన సిబ్బంది — మూడో పక్షం జాప్యం లేదు.",
      },
    },
    con: {
      eyebrow: "సంప్రదించండి",
      h1: "మీ ప్రాజెక్టు గురించి మాట్లాడుదాం",
      para: "ఎంక్వైరీ పంపండి, వాట్సాప్‌లో చాట్ చేయండి లేదా మా తాండూరు కార్యాలయానికి నేరుగా రండి — మేము ఒక పనిదినంలో స్పందిస్తాం.",
      formH2: "ఎంక్వైరీ పంపండి",
      officeH3: "కార్యాలయ వివరాలు",
      whatsappBtn: "వాట్సాప్‌లో చాట్ చేయండి",
      directionsBtn: "దిశలు పొందండి",
      mapH2: "మ్యాప్‌లో మమ్మల్ని చూడండి",
    },
    form: {
      name: "పూర్తి పేరు *",
      phone: "ఫోన్ *",
      email: "ఇమెయిల్",
      service: "కావలసిన సేవ",
      details: "ప్రాజెక్టు వివరాలు",
      namePh: "మీ పేరు",
      servicePh: "సేవను ఎంచుకోండి",
      msgPh: "మీ ప్లాట్, భవనం లేదా ఇంటీరియర్ అవసరం గురించి మాకు తెలియజేయండి...",
      submit: "ఎంక్వైరీ సమర్పించండి",
      submitting: "సమర్పిస్తోంది...",
      errRequired: "దయచేసి మీ పేరు మరియు ఫోన్ నంబర్ నమోదు చేయండి.",
      success: "ఎంక్వైరీ సమర్పించబడింది! మా బృందం త్వరలో మిమ్మల్ని సంప్రదిస్తుంది.",
      errFail: "ఎంక్వైరీ పంపడం సాధ్యం కాలేదు. దయచేసి కాల్ లేదా వాట్సాప్ చేయండి.",
    },
    est: {
      title: "ప్రాజెక్టు ఖర్చు అంచనా",
      subtitle: "తక్షణ సూచనా బడ్జెట్",
      type: "ప్రాజెక్టు రకం",
      area: "నిర్మిత వైశాల్యం (చ.అ.)",
      grade: "ఫినిషింగ్ గ్రేడ్",
      calculate: "అంచనా లెక్కించండి",
      budget: "అంచనా బడ్జెట్",
      rate: "వర్తింపు రేటు",
      timeline: "సూచనా కాలవ్యవధి",
      months: "నెలలు",
      perSqft: "/చ.అ.",
      disclaimer: "ఇది కేవలం సూచన మాత్రమే. తుది కోటేషన్ సైట్ పరిస్థితులు, మటీరియల్స్ & డ్రాయింగ్స్‌పై ఆధారపడుతుంది.",
      discuss: "ఈ అంచనా గురించి మాట్లాడండి",
    },
    types: {
      Residential: "రెసిడెన్షియల్",
      Commercial: "కమర్షియల్",
      Interiors: "ఇంటీరియర్స్",
      "Structural Plan": "స్ట్రక్చరల్ ప్లాన్",
    },
    grades: { Standard: "స్టాండర్డ్", Premium: "ప్రీమియం", Luxury: "లగ్జరీ" },
    cat: {
      All: "అన్నీ",
      "Residential Villas": "రెసిడెన్షియల్ విల్లాలు",
      "Commercial Complexes": "కమర్షియల్ కాంప్లెక్స్‌లు",
      Interiors: "ఇంటీరియర్స్",
      "Structural Planning": "స్ట్రక్చరల్ ప్లానింగ్",
    },
    status: {
      New: "కొత్తది",
      Contacted: "సంప్రదించారు",
      "In Review": "పరిశీలనలో",
      Completed: "పూర్తయింది",
      "In Progress": "పురోగతిలో",
      Upcoming: "రాబోయేది",
    },
    loc: {
      Tandur: "తాండూరు",
      Kodangal: "కోదంగల్",
      Peddamul: "పెద్దమూల్",
      Vikarabad: "వికారాబాద్",
      Telangana: "తెలంగాణ",
    },
  },
};
